import { Component, HostListener, Inject, Input, OnInit, OnDestroy, HostBinding } from '@angular/core';
import { PRIMARY_OUTLET } from '@angular/router';
import { DOCUMENT, Location } from '@angular/common';
import { Subscription } from 'rxjs';

import { BrowserENV, UI_BROWSER_ENV, UI_SCREEN_SCALE } from '../../helper';
import { ListActivatedService } from '../../list/index';
import { RouteCacheController } from '../../router/index';
import { AppController, getDeviceType } from './app-controller';

@Component({
  selector: 'ui-app',
  templateUrl: './app.component.html'
})
export class AppComponent implements OnInit, OnDestroy {
  /**
   * æ ¹æ®ä¸åçå±å¹å®½åº¦ï¼è®¾ç½® html åç´ ç font-size
   * ä¸»è¦ç¨äº rem å¸å±ï¼é»è®¤ä¸º 10
   */
  @Input() baseFontSize: number = 10;
  /**
   * å±å¹ X è½´é»è®¤é»è¾åç´ 
   */
  @Input() screenWidth = 375;
  /**
   * angular è·¯ç±ç name
   */
  @Input() name: string = PRIMARY_OUTLET;

  // æ ¹æ®ä¸åç¯å¢ï¼éè¦æé¡µé¢å¤´é¨å¢é«ç¸å¯¹å°ºå¯¸ï¼ä»¥æ¾ç¤ºæ¶é´ï¼çµæ± çµéç­ä¿¡æ¯ï¼è¿ééè¿æ ·å¼æ¥æ§å¶
  @HostBinding('class.ui-iphone')
  get isIphone() {
    return this.env === BrowserENV.iphone;
  }

  @HostBinding('class.ui-iphone-x')
  get isIphoneX() {
    return this.env === BrowserENV.iphoneX;
  }

  @HostBinding('class.ui-android')
  get isAndroid() {
    return this.env === BrowserENV.android;
  }

  @HostBinding('class.ui-default')
  get isDefault() {
    return this.env === BrowserENV.default;
  }

  showMask: boolean = false;

  private htmlElement: HTMLElement;
  private get defaultDocWidth() {
    return this.screenWidth * this.scale;
  }

  private subs: Array<Subscription> = [];

  constructor(@Inject(DOCUMENT) private document: any,
              @Inject(UI_BROWSER_ENV) private env: BrowserENV,
              @Inject(UI_SCREEN_SCALE) private scale: number,
              private routeCacheController: RouteCacheController,
              private location: Location,
              private appController: AppController,
              private listActivatedService: ListActivatedService) {
  }

  ngOnInit() {
    // æ ¹æ®å½ååºç¨æ¯å¦å¨å¨è·¯ç±å¨ç»è½¬åºä¸­æ¶ï¼åæ¢é®ç½©çæ¾ç¤ºä¸éèï¼é²æ­¢å¤æ¬¡ç¹å»
    this.subs.push(this.appController.transition.subscribe(b => {
      this.showMask = b;
    }));
    // å½å±å¹å¤§å°æ¹åæ¶ï¼åæ´ç¯å¢åé
    this.subs.push(this.appController.onResize.subscribe((env: BrowserENV) => {
      this.env = env;
    }));
    // å½è·¯ç±å°ååæ´æ¶ï¼è®¾ç½®è·¯ç±ç¼å­
    this.subs.push(this.location.subscribe(() => {
      this.routeCacheController.isCacheCurrentView(false);
    }) as Subscription);

    this.htmlElement = this.document.querySelector('html');
    this.resize();
  }

  ngOnDestroy() {
    this.subs.forEach(item => item.unsubscribe());
  }

  @HostListener('window:resize')
  resize() {
    // éè¿å½åè§å£çå®½åº¦ï¼å¨æè®¾ç½® css rem å¼çå¤§å°
    if (!this.htmlElement) {
      return;
    }
    const docWidth = this.htmlElement.getBoundingClientRect().width;
    const scale = docWidth / this.defaultDocWidth;
    this.htmlElement.style.fontSize = `${scale * this.baseFontSize}px`;
    this.appController.resize(getDeviceType());
  }

  @HostListener('document:touchstart')
  documentTouchStart() {
    // å½é¡µé¢æ list ç»ä»¶æ¶ï¼å¦æå¶ä¸­æä¸é¡¹å·²æå¼ slidingï¼å½ç¨æ·ç¹å»å¶å®å°æ¹æ¶ï¼éè¦åå¸å¨å±äºä»¶ï¼æ¥æ¶èµ· sliding
    this.listActivatedService.publish();
  }
}